import React from 'react';
import axios from 'axios';
import useCotizacion from 'src/hooks/useCotizacion';
import { urlCorreoInicialNotificacion } from 'src/services/urls';
import ModalDeleteBeneficiario from '../ModalDeleteBeneficiario';
import { StyledAbutton } from '../styleds';

export const ButtonBar = ({ beneficiario, index }) => {
  const { cotizacion, ...res } = useCotizacion();
  console.log("idCotizacion", res)
  const enviarCorreo = () => {
    axios.post(urlCorreoInicialNotificacion(res.idCotizacion, 'bienvenida')).then((response) => {
      console.log("urlCorreoInicialNotificacion", response);
    })

  }
  return (
    <div className="d-flex flex-row w-100 justify-content-end">
      {/* <StyledActionButton type="button">Guardar</StyledActionButton> */}

      {cotizacion?.urlPdfCotizacion && (
        <StyledAbutton href={cotizacion.urlPdfCotizacion} target="_blank" rel="noopener noreferrer" onClick={() => enviarCorreo()}>
          <i className="pi pi-download" />
          {` Descargar`}
        </StyledAbutton>
      )}
      {!cotizacion?.beneficiarioIgualTitularChecked && (
        <ModalDeleteBeneficiario beneficiario={beneficiario} index={index} />
      )}
    </div>
  );
};
